import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';

import '@portal/ui/tokens.css';

import { App } from './app.js';
import { AuthGate } from './auth/AuthGate.js';

/**
 * §11.4 — never poll. Probe results and notifications arrive on the next navigation,
 * which for an internal tool with tens of users is entirely sufficient.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      refetchInterval: false,
      retry: 1,
    },
  },
});

const container = document.getElementById('root');
if (container === null) {
  throw new Error('#root is missing from index.html');
}

/**
 * `AuthGate` sits **outside** the router and the query client on purpose: nothing should
 * fetch before a token is in place, and no route should be reachable while signed out.
 */
createRoot(container).render(
  <StrictMode>
    <AuthGate>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </AuthGate>
  </StrictMode>,
);
